import { render, staticRenderFns } from "./TypeModal.vue?vue&type=template&id=1598f492"
import script from "./TypeModal.vue?vue&type=script&lang=js"
export * from "./TypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports